import { GET_ALL_SCREEN_DETAILS, GET_ALL_SCREEN_DETAILS_FAIL, GET_ALL_SCREEN_DETAILS_SUCCESS } from "./actionTypes";

export const getScreenDetails = (requestData) => ({
    type: GET_ALL_SCREEN_DETAILS,
    payload: requestData
  });
  
  export const getScreenDetailsSuccess = (data) => ({
    type: GET_ALL_SCREEN_DETAILS_SUCCESS,
    payload: data,
  });
  
  export const getScreenDetailsFail = (error) => ({
    type: GET_ALL_SCREEN_DETAILS_FAIL,
    payload: error,
  });